import type { RowData } from "@tanstack/react-table";

import type { DataTableRow } from "./dataTable.types";

function toItems(value: unknown): unknown[] {
  return Array.isArray(value) ? value : [value];
}

/** Égalité stricte sur les chaînes (valeurs d'URL) : le filtre « auto » de TanStack ferait une recherche partielle (« active » trouverait « inactive »). */
export function matchesFilterValue(
  value: unknown,
  filterValue: unknown,
): boolean {
  return toItems(value).some((item) => String(item) === String(filterValue));
}

export function matchesFilterFn<TData extends RowData>(
  row: DataTableRow<TData>,
  columnId: string,
  filterValue: unknown,
): boolean {
  return matchesFilterValue(row.getValue(columnId), filterValue);
}

export function searchFilterFn<TData extends RowData>(
  row: DataTableRow<TData>,
  columnId: string,
  filterValue: string,
): boolean {
  const search = filterValue.toLowerCase();

  return toItems(row.getValue(columnId)).some(
    (item) =>
      (typeof item === "string" || typeof item === "number") &&
      String(item).toLowerCase().includes(search),
  );
}

export function countMatchingRows(
  facetCountByValue: Map<unknown, number>,
  filterValue: string,
): number {
  return Array.from(facetCountByValue).reduce(
    (count, [value, rowCount]) =>
      matchesFilterValue(value, filterValue) ? count + rowCount : count,
    0,
  );
}
